import { InputAdornment, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { inputBox_style } from './style';

export function Input(props) {
  const {
    value,
    fullWidth = true,
    isReadOnly = false,
    helperText = '',
    isError = false,
    isMulti = false,
    rowMax = 5,
    rowMin = 5,
    placeholder = '',
    size = 'small',
    onChange = () => false,
    endAdornment,
    startAdornment,
    type = '',
    onClick = () => {},
    errorMessage = '',
    variant = 'outlined',
    textFieldStyle = {},
    className = '',
    // defaultValue = '',
    autoFocus = false,
    id = '',
    ...rest
  } = props;

  return (
    <>
      <TextField
        id={id}
        type={type}
        size={size}
        sx={{ ...inputBox_style.textFieldSx, ...textFieldStyle }}
        variant={variant}
        value={value}
        onClick={onClick}
        placeholder={placeholder}
        fullWidth={fullWidth}
        disabled={isReadOnly}
        multiline={isMulti}
        maxRows={rowMax}
        minRows={rowMin}
        onChange={onChange}
        helperText={helperText}
        error={!!isError}
        autoFocus={autoFocus}
        className={`${className}`}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">{startAdornment}</InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ),
        }}
        {...rest}
      />
      {isError && (
        <Typography sx={{ mt: 0.5 }} variant="caption" color="error">
          {errorMessage}
        </Typography>
      )}
    </>
  );
}
Input.propTypes = {
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'number', 'password']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  placeholder: PropTypes.string,
  endIcon: PropTypes.node,
  fullwidth: PropTypes.bool,
  isMulti: PropTypes.bool,
  rowMax: PropTypes.number,
  rowMin: PropTypes.number,
  helperText: PropTypes.string,
  isError: PropTypes.bool,
  classes: PropTypes.object,
  sx: PropTypes.object,
  fullWidth: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  endAdornment: PropTypes.any,
  startAdornment: PropTypes.any,
  onClick: PropTypes.func,
  errorMessage: PropTypes.string,
  textFieldStyle: PropTypes.object,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  id: PropTypes.string,
};
